import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'next-i18next';
import { SentimentNegativeIcon } from '../../../../../../components/HotelDetailsOverlay/components/RatingSection/components/GoodToKnow/components/SentimentNegativeIcon.js';
import { SentimentNeutralIcon } from '../../../../../../components/HotelDetailsOverlay/components/RatingSection/components/GoodToKnow/components/SentimentNeutralIcon.js';
import { SentimentPositiveIcon } from '../../../../../../components/HotelDetailsOverlay/components/RatingSection/components/GoodToKnow/components/SentimentPositiveIcon.js';
import { StatementList } from '../../../../../../components/HotelDetailsOverlay/components/RatingSection/components/GoodToKnow/components/StatementList.js';
import { StatementListItem } from '../../../../../../components/HotelDetailsOverlay/components/RatingSection/components/GoodToKnow/components/StatementListItem.js';
import { REVIEW_SENTIMENT_NEGATIVE, REVIEW_SENTIMENT_NEUTRAL, REVIEW_SENTIMENT_POSITIVE } from '../../../../../../components/HotelDetailsOverlay/models.js';
import { HeadlineMedium, Stack } from '../../../../../../primitives/index.js';
const MAX_STATEMENTS_TO_SHOW = 4;
const iconsBySentiment = {
  [REVIEW_SENTIMENT_POSITIVE]: _jsx(SentimentPositiveIcon, {
    fontScale: "inherit"
  }),
  [REVIEW_SENTIMENT_NEUTRAL]: _jsx(SentimentNeutralIcon, {
    fontScale: "inherit"
  }),
  [REVIEW_SENTIMENT_NEGATIVE]: _jsx(SentimentNegativeIcon, {
    fontScale: "inherit"
  })
};
export const GoodToKnow = ({
  statements
}) => {
  const {
    t
  } = useTranslation();
  if (!statements || statements.length === 0) {
    return null;
  }
  return _jsxs(Stack, {
    children: [_jsx(HeadlineMedium, {
      children: t('hotelDetailsOverlay:ratingSection.goodToKnow.title')
    }), _jsx(StatementList, {
      as: "ul",
      spacing: 0.75,
      children: statements.slice(0, MAX_STATEMENTS_TO_SHOW).map(({
        sentiment,
        text
      }, index) => _jsxs(StatementListItem, {
        children: [iconsBySentiment[sentiment], text]
      }, index))
    })]
  });
};